import React from 'react';
const initialSortOrderState = {
    changeSortOrder: () => { },
    direction: null,
    sortOrder: null
};
const SortOrderContext = React.createContext(initialSortOrderState);
export default SortOrderContext;
//# sourceMappingURL=SortOrderContext.js.map